import { useDeviceType } from "@repo/core/hooks/useDeviceType";
import { Platform } from "react-native";

export const useKeyboardAvoidingView = () => {
  const { isTablet, isWeb } = useDeviceType();

  const getKeyBoardVerticalOffset = () => {
    switch (Platform.OS) {
      case "ios":
        return isTablet ? 120 : 40;
      case "android":
        return isTablet ? 120 : 0;
      default:
        return 0;
    }
  };

  const keyboardVerticalOffset = getKeyBoardVerticalOffset();

  return {
    keyboardVerticalOffset,
    isWeb
  };
};
